import { GET_FAQ_SUCCESS, GET_FAQ_FAIL } from '../actions/types';

const initialState = {
  loading: true,
  faqs: [],
  error: null,
};

export default function faqs(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_FAQ_SUCCESS:
      return {
        ...state,
        faqs: payload,
        loading: false,
      };
    case GET_FAQ_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
